module.exports = __webpack_public_path__ + "img/aaron.493c6fa2.jpg";